import {Component, EventEmitter, Input, OnChanges, OnInit} from '@angular/core';
import {BlockElementLabel} from 'app/entities/blockElements/blockElementContainer';

// @TODO add directive binding here

@Component({
  selector: 'app-tab',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export default class TabComponent implements OnChanges, OnInit {
  @Input() title: string;
  @Input() disabled: boolean = false;
  @Input() selected: boolean = false;
  @Input() enableScrollState: boolean = true;

  @Input() valueCounter: number = 0;
  @Input() enableCounter: boolean = false;
  @Input() foregroundCounter: string;
  @Input() backgroundCounter: string;

  @Input() label?: BlockElementLabel = null;

  changeEvent: EventEmitter<any> = new EventEmitter();

  ngOnChanges(): void {
    this.changeEvent.emit();
  }

  ngOnInit(): void {
  }
}
